export default __webpack_public_path__ + "static/media/redeem-bonus2-2.7425ddff.webp";